import { FORM_PRODUCT_OPTIONS } from './products';

import { DropdownOption } from '@/shared/components/dropdown/ui/types';

export type FieldType = 'phone' | 'dropdown' | 'textarea';

export interface Field {
  name: string;
  className?: string;
  label: string;
  required?: string;
  type?: FieldType;
  options?: DropdownOption[];
  value?: string;
}

export const standardFormFields: Field[] = [
  {
    name: 'name',
    label: 'fieldsName',
    className: '!w-full',
    required: 'fieldsNameError',
  },
  {
    name: 'city',
    label: 'formFieldCity',
    className: '!w-full',
  },
  {
    type: 'phone',
    name: 'phone',
    label: 'fieldsPhone',
    required: 'fieldsPhoneError',
  },
  {
    name: 'email',
    label: 'fieldsEmail',
    className: '!w-full',
    required: 'fieldsEmailError',
  },
  {
    name: 'company',
    label: 'navCompanyName',
    className: '!w-full',
  },
  {
    type: 'dropdown',
    name: 'product',
    label: 'fieldsChoseProductLabel',
    className: '!w-full',
    required: 'product',
    options: FORM_PRODUCT_OPTIONS,
  },
  {
    type: 'textarea',
    name: 'purpose',
    label: 'fieldsDescription',
    className: 'col-span-2 max-sm:col-span-1',
  },
  {
    name: 'source',
    label: 'source',
    value: 'Dev2gis',
    className: '!hidden',
  },
];

export const partnersFormFields: Field[] = [
  {
    name: 'name',
    label: 'fieldsName',
    className: '!w-full',
    required: 'fieldsNameError',
  },
  {
    name: 'site',
    label: 'fieldsSite',
    className: '!w-full',
    required: 'fieldsSiteError',
  },
  {
    type: 'phone',
    name: 'phone',
    label: 'fieldsPhone',
    required: 'fieldsPhoneError',
  },
  {
    name: 'company',
    label: 'fieldsCompanyPartners',
    className: '!w-full',
  },
  {
    name: 'email',
    label: 'fieldsEmail',
    className: '!w-full',
    required: 'fieldsEmailError',
  },
  {
    type: 'textarea',
    name: 'purpose',
    label: 'fieldsDescriptionPartners',
    className: 'col-span-2',
  },
  {
    name: 'city',
    label: 'city',
    value: 'НСК',
    className: '!hidden',
  },
  {
    name: 'product',
    label: 'product',
    value: 'Other',
    className: '!hidden',
  },
  {
    name: 'source',
    label: 'source',
    value: 'Dev2gis',
    className: '!hidden',
  },
];

export const webinarFormFields: Field[] = [
  {
    name: 'name',
    label: 'fieldsName',
    className: '!w-full',
    required: 'fieldsNameError',
  },
  {
    name: 'city',
    label: 'formFieldCity',
    className: '!w-full',
  },
  {
    type: 'phone',
    name: 'phone',
    label: 'fieldsPhone',
    required: 'fieldsPhoneError',
  },
  {
    name: 'email',
    label: 'fieldsEmail',
    className: '!w-full',
    required: 'fieldsEmailError',
  },
  {
    name: 'company',
    label: 'navCompanyName',
    className: '!w-full',
  },
  {
    type: 'dropdown',
    name: 'product',
    label: 'fieldsChoseProductLabel',
    className: '!w-ful !hidden',
    required: 'product',
    value: 'DoubleGisPro',
    options: FORM_PRODUCT_OPTIONS,
  },
  {
    type: 'textarea',
    name: 'purpose',
    label: 'fieldsDescription',
    className: 'col-span-2 max-sm:col-span-1',
    value:
      'Настроить индивидуальный дашборд в 2ГИС Про для участников вебинара в октябре 2025',
  },
  {
    name: 'assignedBy',
    label: 'assignedBy',
    value: '120',
    className: '!hidden',
  },
  {
    name: 'source',
    label: 'source',
    value: 'РокетДата',
    className: '!hidden',
  },
];
